import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { ContenteditableDirective } from "../core/content-editable/contenteditable.directive";

@Component({
  selector: "preview-edit-template",
  templateUrl: "./preview-edit-template.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewEditTemplateComponent {
  @Input() templateParameters;
  @Input() selectedContentEditableScope;
  @Input() selectedContentEditable;
  @Input() isOnlyPreview;
  @Input() selectedUserId;
  @Input() template;
  @Input() templateId;
  @Input() templateUpdateModel;
  @Input() templateFileRef;
  @Input() previewMediaType;
  @Input() hasValueFromDb;
  @Input() userPermissions;
  @Input() communicationsCategoryId;
  @Input() activeIndex;
  @Input() disablePasteEvent;
}
